export type EzyVetRecord = "consult" | "animal";

/**
 * Paths of ezyVet record pages inside a clinic's site, with `{id}` for the
 * record id. ezyVet doesn't publish these, so they start empty: open a consult
 * and an animal in a real or trial site, copy the URL path, and add it here.
 * Until then only a link to the site itself is shown, next to the ids.
 */
export const EZYVET_PATHS: Partial<Record<EzyVetRecord, string>> = {};

const SITE_RE = /^[a-z0-9][a-z0-9-]*(\.trial)?\.ezyvet\.com$/i;

/** https URL of a clinic's ezyVet site, or null for anything that isn't an ezyVet host. */
export function ezyvetSiteUrl(site: string | null | undefined): string | null {
  if (!site || !SITE_RE.test(site)) return null;
  return `https://${site.toLowerCase()}/`;
}

/** Deep link to a record, or null when its path isn't configured or the input is unusable. */
export function ezyvetRecordUrl(
  site: string | null | undefined,
  kind: EzyVetRecord,
  id: string | null | undefined,
  paths: Partial<Record<EzyVetRecord, string>> = EZYVET_PATHS,
): string | null {
  const base = ezyvetSiteUrl(site);
  const path = paths[kind];
  if (!base || !path || !id) return null;
  return base + path.replace(/^\//, "").replace("{id}", encodeURIComponent(id));
}
